import { useI18n } from 'app/components/localization';
import { CheckboxField } from 'app/components/presentation/forms/Fields';
import Link from 'app/components/presentation/link/Link';
import React, { FunctionComponent, useState } from 'react';
import { useBrand } from '../OrganizationContext';

interface IProps {
  showValidationErrors: boolean;
  setAgree: (checked: boolean) => void;
}

/**
 * Renders the global Terms of a Agreement for signup.
 */
const TermsAgreementGlobal: FunctionComponent<IProps> = ({ setAgree, showValidationErrors }) => {
  const [agreeChecked, setAgreeChecked] = useState(false);
  const { t, tx } = useI18n();
  const brand = useBrand();

  const termsLink = brand.termsOfServiceUrl ? (
    <Link
      to={brand.termsOfServiceUrl}
      target="_blank"
    >
      {t('auth.terms-agreement.terms-of-service')}
    </Link>
  ) : null;

  const policyLink = brand.privacyPolicyUrl ? (
    <Link
      to={brand.privacyPolicyUrl}
      target="_blank"
    >
      {t('auth.terms-agreement.privacy-policy')}
    </Link>
  ) : null;

  /**
   * TODO: This component assumes it is being rendered on first party brands only. For that reason, it is
   * relying on the `firstPartyDmm` flag for customizing its behavior. This flag will not be necessary once
   * generic terms agreement customizations are stored on the brand.
   */
  return (
    <CheckboxField
      data-testid="terms-agreement-global"
      data-agree-checkbox
      label={
        brand.firstPartyDmm
          // For the Eikaiwa market, we hide the policy here since we show it near the submit button.
          ? (
            <span data-testid="dmm-terms">{tx('auth.terms-agreement.agreement-dmm', {
              market: brand.name,
              termsLink,
            })}</span>
          )
          : (
            <span data-testid="regular-terms">{tx('auth.terms-agreement.agreement', {
              market: brand.name,
              termsLink,
              policyLink,
            })}</span>
          )
      }
      validationError={(showValidationErrors && !agreeChecked) ?
        t('auth.terms-agreement.validation-agree') : undefined}
      onToggle={(checked: boolean) => {
        if (checked !== agreeChecked) {
          setAgreeChecked(checked);
          setAgree(checked);
        }
      }}
      checked={agreeChecked}
    />
  );
};

export default TermsAgreementGlobal;
